import { Star, Copy, CalendarPlus, RefreshCw, Edit, Trash2, HelpCircle, X } from 'lucide-react';

export const CLIENT_ACTIONS = [
  { id: 'favorite', icon: Star, label: 'Favorite', color: 'text-amber-400', desc: 'Pin this client to the top of the list. Tap again to unpin.' },
  { id: 'duplicate', icon: Copy, label: 'Duplicate', color: 'text-purple-400', desc: 'Make a copy of this client — handy for a new employee at the same company.' },
  { id: 'next', icon: CalendarPlus, label: 'Next Stubs', color: 'text-sky-400', desc: 'See every stub made for this client and create the next ones with new dates (same numbers & template).' },
  { id: 'redo', icon: RefreshCw, label: 'Quick Redo', color: 'text-green-400', desc: 'Jump straight to Paystub Details with all info kept — change dates or amounts and generate.' },
  { id: 'edit', icon: Edit, label: 'Edit', color: 'text-blue-400', desc: 'Open the client from step 1 (template, company, employee…) to change anything.' },
  { id: 'delete', icon: Trash2, label: 'Delete', color: 'text-red-400', desc: 'Move the client to Trash. You can restore it from Trash later.' },
];

const TESTIDS = { favorite: 'favorite-client', duplicate: 'duplicate-client', next: 'update-stubs', redo: 'quick-generate', edit: 'edit-client', delete: 'delete-client' };

export const ClientRowActions = ({ client, isFavorite, hasStubs, handlers }) => (
  <div className="flex items-start gap-0.5 flex-wrap justify-end ml-auto">
    {CLIENT_ACTIONS.filter((a) => a.id !== 'next' || hasStubs).map((a) => (
      <button
        key={a.id}
        type="button"
        onClick={(e) => { e.stopPropagation(); handlers[a.id](e); }}
        title={a.desc}
        data-testid={`${TESTIDS[a.id]}-${client.id}`}
        className={`flex flex-col items-center gap-0.5 w-[58px] py-1.5 rounded-md hover:bg-zinc-700/60 transition-colors ${a.id === 'favorite' && !isFavorite ? 'text-zinc-500' : a.color}`}
      >
        <a.icon className={`w-5 h-5 ${a.id === 'favorite' && isFavorite ? 'fill-amber-400' : ''}`} />
        <span className="text-[10px] leading-tight text-zinc-400">{a.id === 'favorite' && isFavorite ? 'Unfavorite' : a.label}</span>
      </button>
    ))}
  </div>
);

export const ClientButtonKey = ({ open, onToggle }) => (
  <div className="mb-3">
    <button type="button" onClick={onToggle} className="flex items-center gap-1.5 text-xs text-sky-300 hover:text-sky-200" data-testid="client-button-key-toggle">
      {open ? <X className="w-3.5 h-3.5" /> : <HelpCircle className="w-3.5 h-3.5" />}
      {open ? 'Hide button guide' : 'What do these buttons do?'}
    </button>
    {open && (
      <div className="mt-2 grid sm:grid-cols-2 gap-2 rounded-lg border border-zinc-700 bg-zinc-950 p-3" data-testid="client-button-key">
        {CLIENT_ACTIONS.map((a) => (
          <div key={a.id} className="flex items-start gap-2">
            <a.icon className={`w-4 h-4 mt-0.5 shrink-0 ${a.color}`} />
            <p className="text-xs text-zinc-300"><span className="font-semibold text-white">{a.label}:</span> {a.desc}</p>
          </div>
        ))}
      </div>
    )}
  </div>
);
